import _get from "lodash/get";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import nets from 'nets'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import config from '@nerdwallet/app-config';
import transform from '@nerdwallet/transform';
var BASE_URL_CONFIG_KEY = 'SERVICE_URLS.MARKETPLACE';

var baseUrl = _get(config, BASE_URL_CONFIG_KEY);

export default function getProgramFromMarketplace(productId) {
  var url = "".concat(baseUrl, "/marketplace/products/v1/first_time_home_buyer_programs/search?client_id=").concat(config.CLIENT_ID);
  return new Promise(function (resolve, reject) {
    if (!baseUrl) {
      reject(new Error("Missing baseUrl ".concat(BASE_URL_CONFIG_KEY)));
    }

    if (!productId) {
      reject(new Error('Missing productId'));
    }

    nets({
      url: url,
      method: 'POST',
      encoding: 'utf8',
      json: true,
      body: {
        query: [{
          field: 'product.id',
          type: 'eq',
          value: productId
        }]
      }
    }, function (error, response, body) {
      var statusCode = _get(response, 'statusCode');

      if (error || statusCode !== 200) {
        reject(new Error({
          url: url,
          statusCode: statusCode,
          error: _get(body, 'error', error)
        }));
        return;
      }

      resolve(transform({
        name: 'data.products[0].details.display_name.value',
        description: 'data.products[0].details.description.value',
        designation: 'data.products[0].details.designation.value',
        ctaText: 'data.products[0].details.cta_text.value',
        states: 'data.products[0].details.states.value',
        cta: 'data.products[0].details.cta.value',
        bestFor: 'data.products[0].details.best_for_bullets.value',
        disclaimer: 'data.products[0].details.cta_disclaimer.value',
        id: 'data.products[0].id',
        productSlug: 'data.products[0].institution.name'
      }, body));
    });
  });
}